import { useEffect, useState } from 'react';

function formatClock(d: Date): string {
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const ss = String(d.getSeconds()).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}

/**
 * Live-ticking 24h clock for the desktop status bar.
 * Mono + tabular-nums so digits don't jitter as they tick.
 */
export default function StatusClock({ className = '' }: { className?: string }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <time
      dateTime={now.toISOString()}
      title="Local time (24h)"
      className={`font-mono tabular-nums text-sm text-theme-secondary ${className}`.trim()}
    >
      {formatClock(now)}
    </time>
  );
}
